module Meevo.Model {
  /**
   * Simple DTO to represent a set of tracking data that will be stored in the database.
   */
    export class TrackingItem {
        details: any;

        constructor(public noun: Meevo.Model.NounEnum, public verb: Meevo.Model.VerbEnum, payload: any, public mainEntityId?: any, public shortDescription?: string) {
            this.details = this.formatPayload(payload);
        }

        /**
         * Determines if the supplied payload is already in JSON or needs to be string-ified and formats it as needed.
         * @param data
         */
        private formatPayload(data: any): any {
            let ret: any = data;

            try {
                JSON.parse(data);
            } catch (e) {
                ret = JSON.stringify(data);
            }

            return ret;
        }
  }
}